import { Select } from "@chakra-ui/react";
import { SportType } from "../../../models/court/dto/court.dto";

type Props = { sport: SportType; setSport: (sports: SportType[]) => void; }
export default function SportPicker({ sport, setSport }: Props) {
    return (
        <Select
            value={sport}
            onChange={newValue => {
                setSport([newValue.target.value as SportType])
            }}>
            {Object.values(SportType).sort().map((type) => (
                <option key={type} value={type}>
                    {type}
                </option>
            ))}
        </Select>
    );
}
